import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/management/profile')({
  component: Outlet,
  beforeLoad: () => ({ breadcrumb: null }),
});
